import best_img_1 from "../imgs/best_img_1.png";
import best_img_2 from "../imgs/best_img_2.png";
import best_img_3 from "../imgs/best_img_3.png";
import best_img_4 from "../imgs/best_img_4.png";
import best_img_5 from "../imgs/best_img_5.png";
import best_img_6 from "../imgs/best_img_6.png";

export const bestInfo = [
  {
    img: best_img_1,
    id: 0,
  },
  {
    img: best_img_2,
    id: 1,
  },
  {
    img: best_img_3,
    id: 2,
  },
  {
    img: best_img_4,
    id: 3,
  },
  {
    img: best_img_5,
    id: 4,
  },
  {
    img: best_img_6,
    id: 5,
  },
];
